import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "withStroke", "size", "variant", "fluid", "onClick", "templateId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React, { Children } from 'react';
import Default from 'react-bootstrap/Button';
import { useTemplateLoader } from '../../template-loader/template-loader';
import { jsx as _jsx } from "react/jsx-runtime";
export var ButtonBase = function ButtonBase(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      withStroke = _ref.withStroke,
      size = _ref.size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$fluid = _ref.fluid,
      fluid = _ref$fluid === void 0 ? false : _ref$fluid,
      _onClick = _ref.onClick,
      templateId = _ref.templateId,
      rest = _objectWithoutProperties(_ref, _excluded);

  var numberOfChildren = Children.toArray(children).length;

  var _useTemplateLoader = useTemplateLoader(),
      setSelectedTemplate = _useTemplateLoader.setSelectedTemplate;

  var sizeValue = size === 'md' ? undefined : size;
  return /*#__PURE__*/_jsx(Default, _objectSpread(_objectSpread({
    className: classNames(className, (_classNames = {}, _defineProperty(_classNames, "btn-".concat(variant, "-stroke"), withStroke), _defineProperty(_classNames, 'btn-fluid', fluid), _classNames)),
    size: sizeValue,
    variant: variant,
    onClick: function onClick(event) {
      if (templateId) {
        /**
         * If `templateId` is specified, we will override the default behaviour
         * of the click handler in order to trigger the account picker
         *
         * TODO: Move this to the Cta module
         */
        event.preventDefault();
        setSelectedTemplate({
          metadataId: templateId
        });
        return;
      }

      _onClick === null || _onClick === void 0 ? void 0 : _onClick(event);
    }
  }, rest), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: classNames({
        'd-flex align-items-center gap-50 text-capitalize': numberOfChildren > 1
      }),
      children: children
    })
  }));
};